import { ADMIN_API_ORIGIN } from '@/config/domains';
import api from './api';

export interface PublishProductUpdateRequest {
  requestId: string;
  title: string;
  content: string;
  version: string;
  recipientUserIds: string[];
}

export interface PublishProductUpdateReply {
  publicationId: string;
  recipientCount: number;
}

export const productUpdatesApi = {
  async publish(
    request: PublishProductUpdateRequest,
  ): Promise<PublishProductUpdateReply> {
    const reply = (await api.post(
      '/api/desktop/v2/admin/tutti-v2/product-updates',
      request,
      { baseURL: ADMIN_API_ORIGIN },
    )) as unknown as PublishProductUpdateReply;
    if (
      reply.publicationId !== request.requestId ||
      reply.recipientCount !== request.recipientUserIds.length
    ) {
      throw new Error('发布响应与本次消息不一致，请保留内容后重试');
    }
    return reply;
  },
};
